export { default } from "./auth.svelte";
